import Views from '../../../managers/helpers/views';
class ExViews extends Views{ 
    constructor(container, rendition) {
		super(container);
		this._rendition = rendition;
	}

	append(view){
		this._views.push(view);
		if(this.container){
			this.container.appendChild(view.element);
			this._rendition.testAppendItem();
		}
		this.length++;
		return view;
	}

    prepend(view){
		this._views.unshift(view);
		if(this.container){
            if(this.container.firstChild){
			    this.container.insertBefore(view.element, this.container.firstChild);
            }else{
                this.container.appendChild(view.element);
            }
			this._rendition.testAppendItem();
		}
		this.length++;
		return view;
	}

	addSegmentation(type = "append", insetBeforIndex = 1){
		if(this.container){
			if(!$(this.container).children(`.epub-view:nth-child(${insetBeforIndex})`).hasClass(`epub-${type}-segmentation`)){
				let startSegmentation = document.createElement("div");
				startSegmentation.classList.add(`epub-${type}-segmentation`);
				// Style Segmentation
				startSegmentation.style.width = "100%";
				startSegmentation.style.height = 0;
				this.container.insertBefore(startSegmentation, $(this.container).children(`.epub-view:nth-child(${insetBeforIndex})`).get(0));
				this._rendition.testAppendItem();
			}
		}
	}

	remove(view) {
		var index = this._views.indexOf(view);

		if(index > -1) {
			this._views.splice(index, 1);
		}

		this.destroy(view);
		this._rendition.testDeleteItem();

		this.length--;
	}

	clearSegmentation(type = "append"){
		// Remove all segmentation
		$(`.epub-${type}-segmentation`).remove();
		this._rendition.testDeleteItem();
	}

	clear(){
		// Remove all segmentation
		$( ".epub-append-segmentation" ).remove();
		$( ".epub-trim-segmentation" ).remove();

		// Remove all views
		var view;
		var len = this.length;

		if(!this.length) return;

		for (var i = 0; i < len; i++) {
			view = this._views[i];
			this.destroy(view);
		}

		this._views = [];
		this.length = 0;
		this._rendition.testDeleteItem();
	}
}

export default ExViews;